import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  InputGroup,
  Glyphicon,
  Image,
  ListGroup,
  ListGroupItem,
  Carousel,
  Tabs,
  Tab,
  Table,
  Well,
  Alert,
  Radio,
  Checkbox,
  Form
} from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import moment from "moment";
import isEmpty from "lodash.isempty";
import DatePicker from "react-date-picker";
import "./dashboard.scss";
import {
  getCartDetail,
  checkout,
  applyPromoCode,
  removePromoCode,
  storeCredit,
  getcharityList
} from "../../../redux/actions/frontActions";
import { getPaymentSetting } from "../../../redux/actions/payemntSettingAction";

import logo from "../../../img/ddb-logo.png";

import ReactHtmlParser from "react-html-parser";

import { Notification } from "../../../components/notifications";
import PaypalExpressBtn from "react-paypal-express-checkout";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import NumberFormat from "react-number-format";
let rand = require("random-key");

import Cookies from "universal-cookie";

const cookies = new Cookies();

const history = createHashHistory();

let cart = "",
  isLoading = "false",
  voucherStatus = "";
("use strict");

let responseValue = "",
  responseMessage = "",
  responseStatus = "";
let sendAsGift = 0, recipientName = '', recipientEmail = '', personalMessage = '';
class Checkout extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      index: 0,
      direction: null,
      cartError: "",
      paymentType: "",
      addressMethod: "shipping",
      show: false,
      alertMessage: "",
      msgType: "",
      paymentMethod: "",
      cardHolderFirstName: "",
      cardHolderLastName: "",
      cardNumber: "",
      cardMonth: "",
      cardYear: "",
      securityCode: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      phone: "",
      setAddress: "",
      payResult: "",
      promocode: "",
      creditRemain: "",
      creditAmount: "",
      promoStatus: 0,
      environment: "",
      giftBillingInfo: false,
      giftFirstName: "",
      giftLastName: "",
      giftAddress: "",
      giftCity: "",
      giftState: "",
      giftZip: "",
      recipientName: "",
      recipientEmail: "",
      personalMessage: "",
      giftZipError: "",
      checkoutType : "",
      email: "",
      dob: "",
      sameAsBillingAddress: 0,
      shippingFirstName: '',
      shippingLastName: '',
      shippingAddress: '',
      shippingCity: '',
      shippingState: '',
      shippingzip: '',
      shippingPhone: '',
      methodStatus: '',
      address2: '',
      shippingAddress2: '',
      hover: false,
      charity: '',
      charity_id: '',
      charityOption: 'disable',
      payPalStatus: false,
      authorizenetStatus: false, 
      allow_store: 'yes',
      promoApplied: 0,
      card_data: "",
      cardData: 1,
      saveCardData: 0,
      check_card: 0,
      showSaveCard: 0,
    };

    this.handleChange = this.handleChange.bind(this);

    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);

    this.handleCheckout = this.handleCheckout.bind(this);
    this.handlePaymentMethod = this.handlePaymentMethod.bind(this);

    this.validate = this.validate.bind(this);
    this.authorizePaySubmit = this.authorizePaySubmit.bind(this);

    this.applyPromoCode = this.applyPromoCode.bind(this);

    this.freeCheckout = this.freeCheckout.bind(this);
    this.handleStoreCredit = this.handleStoreCredit.bind(this);
  }
  onChangeStartDate = date => { this.setState({ dob: date, dobError: "" })};
  
  hoverOn = (e) => {
    this.setState({ hover: true, hoverID: e.target.attributes.getNamedItem("data-id").value });
  }

  hoverOff = (e) => { 
    this.setState({ hover: false, hoverID: e.target.attributes.getNamedItem("data-id").value });    
  }


  handleBillingInfo = (e) => {
    if (e.target.checked) {
      this.setState({giftBillingInfo: true});
    }else{
      this.setState({giftBillingInfo: false});
    }
  }

  handleCardData = (e) => {
    if (e.target.checked) {
      this.setState({cardData: 0, showSaveCard: 1, saveCardData: 1});
    }else{
      this.setState({cardData: 1, showSaveCard: 0, saveCardData: 1});
    }
  }

  creditCardValue = (e) => {
    if(e.target.value !== ''){
      let index = e.target.value;
      let data = this.state.card_data[index];
      this.setState({cardNumber: data.cardNumber, cardMonth: data.cardExpiryDate.substring(0,2), cardYear: data.cardExpiryDate.substring(2,4)});
    }else{
      this.setState({cardNumber: "", cardMonth: "", cardYear: ""})
    }
    
  }

  handleSaveCardData = (e) => {
    if (e.target.checked) {
      this.setState({saveCardData: 0});
    }else{
      this.setState({saveCardData: 1});
    }
  }

  handleStoreCredit = e => {
    if (e.target.checked) {
      this.setState({ creditAmount: e.target.value });
    } else {
      this.setState({ creditAmount: "" });
    }
  };

  freeCheckout = e => {
    e.preventDefault();
    if (isEmpty(localStorage.getItem("user"))  && this.state.checkoutType == '') {
      this.handleShow();
      this.setState({ promoStatus: 0 });
      this.setState({
        alertMessage: ReactHtmlParser(
          "You must be <Link replace to='/login'>logged in</Link> to checkout. Or checkout as a guest user."
        ),
        msgType: "danger"
      });
    } else {
      const err = this.validate();
      let total = 0;
      if (!isEmpty(this.state.cart)) {
        this.state.cart.map((cart, index) => {
          total = parseInt(total) + parseInt(cart.total);
          return total;
        });
      }
      let storeCredit = ((this.state.creditAmount > total) ? total : this.state.creditAmount);
      if (!err) {
        let userKey = cookies.get("token");
        let referredBy = cookies.get("referredBy");
        let referredLink = cookies.get("referredLink");
        let cartDetail = this.state.cart;

        let shippingAddress = {
            first_name: this.state.shippingFirstName,
            last_name: this.state.shippingLastName,
            line_1: this.state.shippingAddress,
            line_2: this.state.shippingAddress2,
            city: this.state.shippingCity,
            state: this.state.shippingState,
            zip: this.state.shippingzip,
            phone: this.state.shippingPhone,
        }

        let setAddress = {
          first_name: this.state.cardHolderFirstName,
          last_name: this.state.cardHolderLastName,
          line_1: this.state.address,
          line_2: this.state.address2,
          city: this.state.city,
          state: this.state.state,
          zip: this.state.zip
        };

        let setGiftAddress = {
          first_name: this.state.giftFirstName,
          last_name: this.state.giftLastName,
          address: this.state.giftAddress,
          city: this.state.giftCity,
          state: this.state.giftState,
          zip: this.state.giftZip
        }

        if(this.state.giftBillingInfo){
          this.setState({sameAsBillingAddress: 1});
        }

        let responseText = {
          payer_id: "0",
          store_credit: storeCredit ? storeCredit : 0,
          amount: "0",
          email: this.state.email,
          dob: moment(this.state.dob).format('YYYY-MM-DD'),
          status: "success",
          currency: "USD",
          token: "0",
          paymentMethod: "FREE",
          transaction_id: "0",
          userKey: userKey,
          billing_address: setAddress,
          shipping_address: (this.state.sameAsBillingAddress == 1) ? setAddress : shippingAddress,
          items: cartDetail,
          referredBy: referredBy,
          referredLink: referredLink,
          recipientAddress : (sendAsGift === 1) ? setGiftAddress : '',
          recipientName: (this.state.recipientName) ? this.state.recipientName : recipientName,
          recipientEmail: (this.state.recipientEmail) ? this.state.recipientEmail : recipientEmail,
          personalMessage: (this.state.personalMessage) ? this.state.personalMessage : personalMessage,
          sameAsBillingAddress: this.state.sameAsBillingAddress,
          charity_id: this.state.charity_id,
        };

        if(this.state.checkoutType == "guest"){
          this.props.checkout(responseText, 'payment/save-payment-detail-guest');
        }else{
          this.props.checkout(responseText, 'payment/save-payment-detail');
        }

        // this.props.checkout(responseText);
        this.handlePageChange(1);
      }
    }
  };

  removePromoCode = e =>{
    e.preventDefault();
    isLoading = "true";
    let cartTotal = 0;
    this.props.removePromoCode({
      userKey: cookies.get("token"),
      promoCode: this.state.promocode,
    });
  }

  applyPromoCode = e => {
    e.preventDefault();
    if (this.state.promocode) {
      isLoading = "true";
      let cartTotal = 0;
      if (!isEmpty(this.state.cart)) {
        this.state.cart.map((cart, index) => {
          cartTotal = parseInt(cartTotal) + parseInt(cart.total);
          return cartTotal;
        });
      }

      this.props.applyPromoCode({
        userKey: cookies.get("token"),
        promoCode: this.state.promocode,
        using_store_credit: (this.state.creditAmount > 0) ? "yes" : "no",
        store_amount: this.state.creditAmount,
        total_amount: (cartTotal) ? cartTotal : '',
        user_info: (localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : this.state.email,
      });

      this.handlePageChange();
    } else {
      let isError = true;
      this.setState({ promocodeError: "red" });
    }
  };

  handlePaymentMethod(e) {
    if (isEmpty(localStorage.getItem("user"))  && this.state.checkoutType == '') {
      this.handleShow();
      this.setState({ promoStatus: 0 });
      this.setState({
        alertMessage: ReactHtmlParser(
          "You must be <Link replace to='/login'>logged in</Link> to checkout. Or checkout as a guest user."
        ),
        msgType: "danger",
        methodStatus: e.target.value,
      });
    } else {
      if(e.target.value === 'paypal'){
        let valid = this.validate();
        if(valid){
          this.setState({ paymentMethod: e.target.value });
        }else{
          this.setState({ paymentMethod: '' });
        }
      }else{
        this.setState({ paymentMethod: e.target.value });
      }
    }
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  handleCheckout() {
    if (isEmpty(localStorage.getItem("user")) && this.state.checkoutType == '') {
      this.handleShow();
      this.setState({ promoStatus: 0 });
      this.setState({
        alertMessage:
          "You must be <Link replace to='/login'>logged in</Link> to checkout. Or checkout as a guest user.",
        msgType: "danger"
      });
    } else {
    }
  }

  handleChange(e) {
    if(e.target.name == 'promocode'){
      this.setState({ [e.target.name]: e.target.value.toUpperCase() });
    }else{
      this.setState({ [e.target.name]: e.target.value });
    }

    if (`${e.target.name}Error` !== "") {
      if (e.target.name == "cardNumber") {
        if (e.target.value.length !== 16) {
          this.setState({ [`${e.target.name}Error`]: "red" });
        } else {
          this.setState({ [`${e.target.name}Error`]: "green" });
        }
      } else if (e.target.name == "cardMonth") {
        if (
          e.target.value.length !== 2 &&
          e.target.value < 1 &&
          e.target.value > 12
        ) {
          this.setState({ [`${e.target.name}Error`]: "red" });
        } else {
          this.setState({ [`${e.target.name}Error`]: "green" });
        }
      } else if (e.target.name == "cardYear") {
        if (e.target.value.length !== 2) {
          this.setState({ [`${e.target.name}Error`]: "red" });
        } else {
          this.setState({ [`${e.target.name}Error`]: "green" });
        }
      } else {
        this.setState({ [`${e.target.name}Error`]: "green" });
      }
    }
  }

  handlePageChange = page => {
    isLoading = "true";
    this.props.getCartDetail({ userKey: cookies.get("token") });
    this.props.storeCredit();
    this.props.getPaymentSetting();
  };

  componentWillMount() {
    if(this.props.themeData){
      if(this.props.themeData.button){
        this.setState({
          button_color: this.props.themeData.button.button_color,
          mouseover_color: this.props.themeData.button.mouseover_color,
        });
      }
    }
    this.props.clearAlert();
    this.handleDismiss();
    this.handlePageChange(1);
    this.props.getcharityList();
    let siteData = JSON.parse(localStorage.getItem('siteDDBStatus'));
    if(siteData){
      this.setState({charityOption: siteData.charity, check_card: siteData.check_card});
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.themeData){
      if(nextProps.themeData.button){
        this.setState({
          button_color: nextProps.themeData.button.button_color,
          mouseover_color: nextProps.themeData.button.mouseover_color,
        });
      }
    }
    // cart detail
    if (this.props.cartDetail != nextProps.cartDetail) {
      if (nextProps.cartDetail) {
        isLoading = "false";
        if (cookies.get("affiliateID")) {
          let checkDealID = cookies.get("affiliateID");
          const newCart = nextProps.cartDetail.data.data.map((data, pidx) => {
            if (checkDealID.dealID !== data.dealID) return data;
            return { ...data, affiliated_by: checkDealID.affiliateID };
          });
          this.setState({ cart: newCart });
        } else {
          this.setState({ cart: nextProps.cartDetail.data.data });
        }
        if(nextProps.cartDetail.data.show_store == 'no'){
          this.setState({allow_store: nextProps.promoStatus.allow_store, creditAmount: ""})
        }
      } else {
        cart = "empty";
      }
    }
    if(this.props.getCharity !== nextProps.getCharity){
      if(nextProps.getCharity){
        this.setState({charity: nextProps.getCharity});
      }
    }
    if (this.props.creditAmount != nextProps.creditAmount) {
      if (nextProps.creditAmount) {
        isLoading = "false";

        this.setState({ creditRemain: nextProps.creditAmount.data, card_data: nextProps.creditAmount.card_data });
      }
    }
    // cart status
    if (this.props.cartStatus != nextProps.cartStatus) {
      if (nextProps.cartStatus) {
        isLoading = "false";

        this.setState({ cartStatus: nextProps.cartStatus });
      }
    }

    if (this.props.cartError != nextProps.cartError) {
      if (nextProps.cartError) {
        this.setState({ promoStatus: 0 });
        responseValue = "";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.cartError);
        isLoading = "false";
      }
    }

    if (this.props.checkoutStatus != nextProps.checkoutStatus) {
      if (nextProps.checkoutStatus) {
        this.setState({ promoStatus: 0 });
        if(nextProps.checkoutStatus.data.response == 'error'){
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("danger", nextProps.checkoutStatus.data.message);
          isLoading = "false";
        }else{
          this.props.clearAlert();
          this.handleShow();
          this.props.renderAlert("success", "The payment was succeeded!");
          isLoading = "false";
          voucherStatus = "generated";
          responseValue = "";
          responseStatus = "";
          cookies.remove("affiliateID");
          cookies.remove("token");
          this.handlePageChange(1);
        }
      }
    }

    if (this.props.promoError != nextProps.promoError) {
      if (nextProps.promoError) {
        this.setState({ promoStatus: 1 });
        responseValue = "";
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.promoError);
        isLoading = "false";
      }
    }

    if (this.props.promoStatus != nextProps.promoStatus) {
      if (nextProps.promoStatus) {
        this.setState({ promoStatus: 1, promoApplied: 1 });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.promoStatus.message);
        isLoading = "false";
        if(nextProps.promoStatus.allow_store == 'no'){
        this.setState({allow_store: nextProps.promoStatus.allow_store, creditAmount: ""})
        }
        this.handlePageChange();
      }
    }

    if (this.props.removeStatus != nextProps.removeStatus) {
      if (nextProps.removeStatus) {
        this.setState({promoStatus: 0, allow_store: 'yes', promoApplied: 0});
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.removeStatus.message);
        isLoading = "false";
        this.handlePageChange();
      }
    }

    if (this.props.message !== nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.paymentSetting !== nextProps.paymentSetting) {
      if (nextProps.paymentSetting) {
        let data = nextProps.paymentSetting.data;
        let checkStatus = false;
        if(data.environment == 'live'){
          if(data.authorizeLiveLoginID != '' && data.authorizeLiveTransactionKey != ''  && data.authorizeLiveSecretKey != ''){
            checkStatus = true;
            this .setState({authorizenetStatus: true, authStatus: true, paymentMethod: 'card'});
          }
          if(data.paypalLiveUsername != '' && data.paypalLivePassword != ''  && data.paypalLiveSignature != ''){
            if(checkStatus === true){
              this .setState({payPalStatus: true, paypalStatus: false, paymentMethod: 'card'});
            }else{
              this .setState({payPalStatus: true, paypalStatus: true, paymentMethod: 'paypal'});
            }
          }
        }else{
          if(data.authorizeSandBoxLoginID != null && data.authorizeSandBoxTransactionKey != null  && data.authorizeSandBoxTransactionKey != null){
            checkStatus = true;
            this .setState({authorizenetStatus: true, authStatus: true, paymentMethod: 'card'});
          }
          if(data.paypalSandBoxUsername != null && data.paypalSandBoxPassword != null  && data.paypalSandBoxSignature != null){
            if(checkStatus === true){
              this .setState({payPalStatus: true, paypalStatus: false, paymentMethod: 'card'});
            }else{
              this .setState({payPalStatus: true, paypalStatus: true, paymentMethod: 'paypal'});
            }
          }
        }
        this.setState({
          guestCheckout: data.guestCheckout,
          referall: data.referall,
          environment: data.environment,
          paypalSandBoxUsername: data.paypalSandBoxUsername,
          paypalSandBoxPassword: data.paypalSandBoxPassword,
          paypalSandBoxSignature: data.paypalSandBoxSignature,
          paypalLiveUsername: data.paypalLiveUsername,
          paypalLivePassword: data.paypalLivePassword,
          paypalLiveSignature: data.paypalLiveSignature
        });
      }
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.cartDetail != nextState.cartDetail) {
      if (nextState.cartDetail) {
        this.setState({ cart: nextState.cartDetail });
      }
    }
  }

  payPalPaymentStatus(payment) {
    this.setState({ status: payment });
  }

  paymentStatus(message, status, responseText) {
    this.handleShow();
    if(this.state.checkoutType == "guest"){
      this.props.checkout(responseText, 'payment/save-payment-detail-guest');
    }else{
      this.props.checkout(responseText, 'payment/save-payment-detail');
    }

    // this.props.checkout(responseText);
    if (status == "danger") {
      this.setState({ promoStatus: 0 });
      this.setState({ alertMessage: message, msgType: status });
    } else {
      this.handlePageChange(1);
    }
  }

  validate = () => {

    let isError = false;
    const errors = {};

    if( this.state.checkoutType == 'guest' ){
      if (!this.state.email) {
        isError = true;
        this.setState({ emailError: "red" });
      }
      if (!this.state.dob) {
        isError = true;
        this.setState({ dobError: "red" });
      }
    }

    if (this.state.paymentMethod === "card" && this.state.total > 0) {

      if (!this.state.cardHolderFirstName) {
        isError = true;
        this.setState({ cardHolderFirstNameError: "red" });
      }

      if (!this.state.cardHolderLastName) {
        isError = true;
        this.setState({ cardHolderLastNameError: "red" });
      }

      if (!this.state.cardNumber) {
        isError = true;
        this.setState({ cardNumberError: "red" });
      }

      let cardNumber = this.state.cardNumber;
      if(typeof cardNumber == "number"){
        cardNumber = cardNumber.toString();
      }

      if (cardNumber.length !== 16) {
        isError = true;
        this.setState({ cardNumberError: "red" });
      }

      if (!this.state.cardMonth) {
        isError = true;
        this.setState({ cardMonthError: "red" });
      }

      if (this.state.cardMonth.length !== 2) {
        isError = true;
        this.setState({ cardMonthError: "red" });
      }

      if (!this.state.cardYear) {
        isError = true;
        this.setState({ cardYearError: "red" });
      }

      if (this.state.cardYear.length !== 2) {
        isError = true;
        this.setState({ cardYearError: "red" });
      }

      if (!this.state.securityCode) {
        isError = true;
        this.setState({ securityCodeError: "red" });
      }
    }

    if (!this.state.address) {
      isError = true;
      this.setState({ addressError: "red" });
    }

    if (!this.state.city) {
      isError = true;
      this.setState({ cityError: "red" });
    }

    if (!this.state.state) {
      isError = true;
      this.setState({ stateError: "red" });
    }

    if (!this.state.zip) {
      isError = true;
      this.setState({ zipError: "red" });
    }

    if (!this.state.phone) {
      isError = true;
      this.setState({ phoneError: "red" });
    }

    if(sendAsGift === 1){

      if(!this.state.giftBillingInfo){

        if(!this.state.giftFirstName){
          isError = true;
          this.setState({ giftFirstNameError: "red" });
        }

        if(!this.state.giftLastName){
          isError = true;
          this.setState({ giftLastNameError: "red" });
        }

        if(!this.state.giftAddress){
          isError = true;
          this.setState({ giftAddressError: "red" });
        }

        if(!this.state.giftCity){
          isError = true;
          this.setState({ giftCityError: "red" });
        }

        if(!this.state.giftState){
          isError = true;
          this.setState({ giftStateError: "red" });
        }

        if(!this.state.giftZip){
          isError = true;
          this.setState({ giftZipError: "red" });
        }

      }

    }

    // shipping address validation
    if(this.state.sameAsBillingAddress == 0){
      if(!this.state.shippingFirstName){
          isError = true;
          this.setState({ shippingFirstNameError: "red" });
      }
      if(!this.state.shippingLastName){
          isError = true;
          this.setState({ shippingLastNameError: "red" });
      }
      if(!this.state.shippingAddress){
          isError = true;
          this.setState({ shippingAddressError: "red" });
      }
      if(!this.state.shippingCity){
          isError = true;
          this.setState({ shippingCityError: "red" });
      }
      if(!this.state.shippingState){
          isError = true;
          this.setState({ shippingStateError: "red" });
      }
      if(!this.state.shippingzip){
          isError = true;
          this.setState({ shippingzipError: "red" });
      }
      if(!this.state.shippingPhone){
          isError = true;
          this.setState({ shippingPhoneError: "red" });
      }
    }

    return isError;
  };

  totalAmount(total) {
    this.setState({ total: total });
  }

  authorizePaySubmit(e) {
    e.preventDefault();
    const err = this.validate();
    if (!err) {
      isLoading = "true";
      let userKey = cookies.get("token");
      let referredBy = cookies.get("referredBy");
      let referredLink = cookies.get("referredLink");
      let total_amount = this.state.total;
      let cartDetail = this.state.cart;
      let cardNumber = this.state.cardNumber;
      let cardExpiryDate = this.state.cardMonth + this.state.cardYear;
      let email = this.state.email;
      let dob = this.state.dob;
      
      let recipientNameData =  (this.state.recipientName) ? this.state.recipientName : recipientName;
      let recipientEmailData = (this.state.recipientEmail) ? this.state.recipientEmail : recipientEmail;
      let personalMessageData = (this.state.personalMessage) ? this.state.personalMessage : personalMessage;
      if(this.state.giftBillingInfo){
          this.setState({sameAsBillingAddress: 1});
      }
      let giftBillingInfo = this.state.sameAsBillingAddress;
      let shippingAddress = {
        first_name: this.state.shippingFirstName,
        last_name: this.state.shippingLastName,
        line_1: this.state.shippingAddress,
        line_2: this.state.shippingAddress2,
        city: this.state.shippingCity,
        state: this.state.shippingState,
        zip: this.state.shippingzip,
        phone: this.state.shippingPhone,
      }
      let setAddress = {
        first_name: this.state.cardHolderFirstName,
        last_name: this.state.cardHolderLastName,
        line_1: this.state.address,
        line_2: this.state.address2,
        city: this.state.city,
        state: this.state.state,
        zip: this.state.zip,
        phone: this.state.shippingPhone,
      };

      let setGiftAddress = {
        first_name: this.state.giftFirstName,
        last_name: this.state.giftLastName,
        address: this.state.giftAddress,
        city: this.state.giftCity,
        state: this.state.giftState,
        zip: this.state.giftZip
      }

      let recipientAddressData = (sendAsGift === 1) ? setGiftAddress : '';

      let store_credit = this.state.creditAmount ? this.state.creditAmount : 0;
      let checkDealID = (cookies.get("affiliateID")) ? cookies.get("affiliateID") : ''; 
      let responseValue = {
        store_credit: store_credit,
        amount: total_amount,
        email: email,
        dob: moment(dob).format('YYYY-MM-DD'),
        affiliateID: (cookies.get("affiliateID")) ? checkDealID.affiliateID : '',
        currency: "USD",
        paymentMethod: "authorizenet",
        userKey: userKey,
        billing_address: setAddress,
        shipping_address: (giftBillingInfo == 1) ? setAddress : shippingAddress,
        items: cartDetail,
        referredBy: referredBy,
        referredLink: referredLink,
        recipientAddress : recipientAddressData,
        recipientName: recipientNameData,
        recipientEmail: recipientEmailData,
        personalMessage: personalMessage,
        sameAsBillingAddress : giftBillingInfo,
        cardNumber: cardNumber,
        cardExpiryDate: cardExpiryDate,
        securityCode: this.state.securityCode,
        charity_id: this.state.charity_id,
        saveCardData: this.state.saveCardData,
      };
      if(this.state.checkoutType == "guest"){
        this.props.checkout(responseValue, 'payment/save-payment-detail-guest');
      }else{
        this.props.checkout(responseValue, 'payment/save-payment-detail');
      }
    }
  }


  checkoutTypeStatus = (e) => {
    this.setState({checkoutType: 'guest',  paymentMethod: (this.state.paymentMethod) ? this.state.paymentMethod : ''})
  }

  handleGuestChange = (e) => {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "green" });
    }
    this.setState({[e.target.name] : e.target.value});

  }
  sameAsBillingAddress = (e) => {
    if(e.target.checked){
      this.setState({sameAsBillingAddress: 1});
    }else{
      this.setState({sameAsBillingAddress: 0});
    }
  }


  convertStringObjToArr = (attrObj) => {
    let objAttributes = JSON.parse(attrObj);
    let objArr = [];
    if(objAttributes.attribute && !isEmpty(objAttributes.attribute)){
      objArr = objAttributes.attribute;
    }
    return objArr;
  }

  renderAttributes = (attrData) => {
    let tmparray = [];
    let attrArray = Object.keys(attrData).map((aObj, aindex) => {
      tmparray.push({name: aObj, data: attrData[aObj]});
    });
    return tmparray
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.cart === nextState.cartDetail) {
        return false
    }
    return true
  }

  render() {
    const { index, direction, payResult } = this.state;
    let responseText = {};
    let userKey = cookies.get("token");
    let referredBy = cookies.get("referredBy");
    let referredLink = cookies.get("referredLink");
    let cartItem,
      i = 1,
      total = 0,
      subRetailPrice = 0,
      subOfferPrice = 0,
      subTotalShipping = 0,
      taxPerc = 0,
      subTotalQty = 0;

    if (!isEmpty(this.state.cart)) {
      cartItem = this.state.cart.map((cart, index) => {
        total = parseFloat(total) + parseFloat(cart.total);
        subTotalQty = parseFloat(subTotalQty) + parseFloat(cart.quantity);
        subRetailPrice = parseFloat(subRetailPrice) + parseFloat(cart.retailPrice);
        subOfferPrice = parseFloat(subOfferPrice) + parseFloat(cart.offerPrice);
        taxPerc = parseFloat(taxPerc) + parseFloat(cart.tax);
        subTotalShipping = parseFloat(subTotalShipping) + parseFloat(cart.shipping);
          if(cart.sendAsGift === 1){ 
            sendAsGift = cart.sendAsGift;
            recipientName = cart.recipientName;
            recipientEmail = cart.recipientEmail;
            personalMessage = cart.personalMessage;
          }
        });
    }

    // Paypal Payment Gateway Integration Start

    const onSuccess = payment => {
      let shippingAddress = {
          first_name: this.state.shippingFirstName,
          last_name: this.state.shippingLastName,
          line_1: this.state.shippingAddress,
          line_2: this.state.shippingAddress2,
          city: this.state.shippingCity,
          state: this.state.shippingState,
          zip: this.state.shippingzip,
          phone: this.state.shippingPhone,
      }
      let setGiftAddress = {
        first_name: this.state.giftFirstName,
        last_name: this.state.giftLastName,
        address: this.state.giftAddress,
        city: this.state.giftCity,
        state: this.state.giftState,
        zip: this.state.giftZip
      }

      if(this.state.giftBillingInfo){
          this.setState({sameAsBillingAddress: 1});
      }
      let checkDealID = (cookies.get("affiliateID")) ? cookies.get("affiliateID") : '';
      responseText = {
        payer_id: payment.payerID,
        affiliateID: (cookies.get("affiliateID")) ? checkDealID.affiliateID : '',
        email: this.state.email,
        dob: moment(this.state.dob).format('YYYY-MM-DD'),
        store_credit: this.state.creditAmount ? this.state.creditAmount : 0,
        amount: total - this.state.creditAmount,
        status: "success",
        currency: currency,
        token: payment.paymentToken,
        paymentMethod: "paypal",
        transaction_id: payment.paymentID,
        userKey: userKey,
        billing_address: JSON.stringify(payment.address),
        shipping_address: (this.state.sameAsBillingAddress == 1) ? JSON.stringify(payment.address) : shippingAddress,
        items: this.state.cart,
        referredBy: referredBy,
        referredLink: referredLink,
        recipientAddress : (sendAsGift === 1) ? setGiftAddress : '',
        recipientName: (this.state.recipientName) ? this.state.recipientName : recipientName,
        recipientEmail: (this.state.recipientEmail) ? this.state.recipientEmail : recipientEmail,
        personalMessage: (this.state.personalMessage) ? this.state.personalMessage : personalMessage,
        sameAsBillingAddress: this.state.sameAsBillingAddress,
        charity_id: this.state.charity_id,
      };
      this.payPalPaymentStatus(payment);
      this.paymentStatus("The payment was succeeded!", "success", responseText);
    };

    const onCancel = data => {
      responseText = {
        amount: total,
        status: "cancel",
        currency: currency,
        token: data.paymentToken,
        paymentMethod: "paypal",
        transaction_id: data.paymentID,
        userKey: userKey,
        items: this.state.cart,
        declineMessage: "The payment was cancelled!",
        charity_id: this.state.charity_id,
      };
      this.payPalPaymentStatus(data);
      this.paymentStatus("The payment was cancelled!", "danger", responseText);
    };

    const onError = err => {
      responseText = {
        amount: total,
        status: "cancel",
        currency: currency,
        token: data.paymentToken,
        paymentMethod: "paypal",
        transaction_id: data.paymentID,
        userKey: userKey,
        items: this.state.cart,
        declineMessage: err,
      };
      this.paymentStatus(`Error:$(err)`, "danger", responseText);
    };

    let currency = "USD"; // or you can set this value from your props or state
    let env; // you can set here to 'production' for production
    if (this.state.environment == "sandbox") {
      env = "sandbox";
    } else {
      env = "production";
    }

    const client = {
      sandbox: this.state.paypalSandBoxSignature,
      production: this.state.paypalLiveSignature
    };

    // Paypal Payment Gateway Integration End
    return (
      <div>
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        
        {isEmpty(this.state.cart) && this.state.cart == '' ? (
          voucherStatus == "generated" ? (
            <div className="container margin-top">
              <Well bsSize="large" className="margin-top">
                <p><b>Success! You’ve Scored the Deal!!</b></p>
                <p>Give our system just a few minutes to magically put together your voucher and then you can find your coupon code by accessing the MY ACCOUNT link at the top of {window.location.host}.</p>
                <p>All of your order history and certificate links are located on this page. Please print and take the coupon, with it's unique code, to the merchant location to redeem within restrictions and prior to expiration date.</p>
                <p>You saved some major moolah, my friend. Feel good about that! But, if you have any questions
                regarding your deal, please contact us at support@{window.location.host}.</p>
              </Well>
              <Button
                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Continue Shoping') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {'Continue Shoping'}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={() => history.push(`/`)}
              >
                Continue Shopping
              </Button>
            </div>
          ) : (
            (this.state.cart == '') &&
            <div className="container margin-top text-center">
              <Well bsSize="large"  className="margin-top">
                <h1>Your cart is empty. Please add some offers.</h1>
              </Well>
              <Button
                style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Continue Shoping') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                data-id = {'Continue Shoping'}
                onMouseEnter={this.hoverOn} 
                onMouseLeave={this.hoverOff}
                bsStyle="success"
                type="submit"
                onClick={() => history.push(`/`)}
              >
                Continue Shopping
              </Button>
            </div>
          )
        ) : (
          <form
            onSubmit={
              total - this.state.creditAmount > 0
                ? this.authorizePaySubmit
                : this.freeCheckout
            }
          >
            <div className="container">
              <div className="panel">
                <header className="panel-heading">
                  Confirm your order and checkout
                </header>
                <div className="panel-body">
                  {(isEmpty(localStorage.getItem("user"))) &&
                    <Row>
                      <Col md={12} xs={12} className="text-center">
                      <Button 
                        style={{backgroundColor: (this.state.hover && this.state.hoverID == "login") ? this.state.mouseover_color : '#77C84E'}} 
                        data-id = {"login"}
                        onMouseEnter={this.hoverOn} 
                        onMouseLeave={this.hoverOff} 
                        bsStyle={(!this.state.checkoutType) ? "success" : "danger"} 
                        onClick={() => history.push('/login')}
                      >
                        Log In
                      </Button>
                        {(this.state.guestCheckout == 'enable') &&
                        <React.Fragment>
                        - OR -
                        <Button 
                        style={{backgroundColor: (this.state.hover && this.state.hoverID == "guest") ? this.state.mouseover_color : this.state.button_color}}
                        data-id = {"guest"}
                        onMouseEnter={this.hoverOn} 
                        onMouseLeave={this.hoverOff} 
                        onClick={this.checkoutTypeStatus} bsStyle={(this.state.checkoutType) ? "success" : "danger"}
                      >Guest Checkout</Button>
                      </React.Fragment>
                      }</Col>
                    </Row>
                  }
                  <Table striped bordered condensed hover className="margin-top cartgrid">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Offer</th>
                        <th>Qty</th>
                        <th>Retail Price</th>
                        <th>Offer Price</th>
                        <th>Shipping</th>
                        <th>Tax</th>
                        <th>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {!isEmpty(this.state.cart)
                        ? (cartItem = this.state.cart.map((cart, index) => (
                            <tr key={Math.random()}>
                              <td className="none">{i++}</td>
                              <td className="offer">
                                {cart.mainDealText}
                                {!isEmpty(cart.cart_title) &&
                                  <div className="margin-top">Location : {cart.cart_title}, {cart.cart_stateAbbr}, {cart.cart_country} </div>
                                }
                                {!isEmpty(cart.cart_attributes) &&
                                 this.convertStringObjToArr(cart.cart_attributes).map((attrData) => {
                                  return <Row
                                    // className="margin-top"
                                    key={Math.random()}
                                  >
                                    <Col md={12} xs={12} key={Math.random()}>
                                      {this.renderAttributes(attrData).map((gtyVal, qtyIndex) => {
                                          return <div key={qtyIndex}>
                                              Item Attribute => {gtyVal.name} :: {gtyVal.data}
                                          </div>
                                      })}
                                    </Col>
                                  </Row>
                                })}
                                <hr />
                                {ReactHtmlParser(cart.termsAndConditions)}
                              </td>
                              <td className="qty">{cart.quantity}</td>
                              <td className="rprice">${cart.retailPrice}</td>
                              <td className="oprice">${cart.offerPrice}</td>
                              <td className="shipping">${cart.shipping}</td>
                              <td className="tax">{cart.tax}%</td>
                              <td className="total">${cart.total}</td>
                            </tr>
                          )))
                        : null}
                      
                      {(!isEmpty(this.state.cart) && this.state.cart.length > 1) &&
                         <tr>
                          <td className="none"></td>
                          <td className="pull-right none">Sub Total</td>
                          <td className="subqty">{subTotalQty}</td>
                          <td className="subrprice">${subRetailPrice.toFixed(2)}</td>
                          <td className="text-center suboprice">${subOfferPrice.toFixed(2)}</td>
                          <td className="subshipping"><b>${subTotalShipping.toFixed(2)}</b></td>
                          <td className="text-center suboprice">{taxPerc.toFixed(2)}%</td>
                          <td className="total"><b>${total.toFixed(2)}</b></td>
                        </tr>
                      }
                      <tr>
                        <td className="none" colSpan="5" />
                        <td colSpan="2" className="text-center none">
                          Grand Total
                        </td>
                        <td>
                          <b>${total.toFixed(2)}</b>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
              {/* Promocode Container*/}
              <div className="panel">
                <div className="panel-body">
                  <Row>
                    <Col md={4} xs={12}>
                      <FormGroup controlId="formPromoCodeTitle">
                        <ControlLabel>Have a Promo Code?</ControlLabel>
                        <p>If so, enter it and save even more!</p>
                      </FormGroup>
                    </Col>
                    <Col md={3} xs={12}>
                      <FormGroup controlId="formCodeTitle">
                        {this.state.promoStatus == 0 &&
                        <p className="pull-right">Promotional Code:</p>
                        }
                      </FormGroup>
                    </Col>
                    <Col md={4} xs={12}>
                      {this.state.promoApplied == 0 ?
                      <FormGroup controlId="formPromoCode">
                        <FormControl
                          type="text"
                          value={this.state.promocode}
                          placeholder="Enter Promo Code"
                          onChange={this.handleChange}
                          name="promocode"
                          style={{ borderColor: this.state.promocodeError }}
                        />
                      </FormGroup>
                      :
                      <p>Applied promo code: <b className="text-success">{this.state.promocode}</b></p>
                      }
                      <span className="text-danger"><b>{(this.state.allow_store == 'no') ? "Store credit cannot be used with this promo code." : ""}</b></span>
                    </Col>
                    <Col md={1} xs={12}>
                      {this.state.promoApplied == 0 ?
                      <Button 
                        style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Apply') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                        data-id = {'Apply'}
                        onMouseEnter={this.hoverOn} 
                        onMouseLeave={this.hoverOff}
                        bsStyle="success" onClick={this.applyPromoCode}
                      >
                        Apply
                      </Button>
                      :
                      <Button 
                        style={{backgroundColor: (this.state.hover && this.state.hoverID == 'Apply') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                        data-id = {'Apply'}
                        onMouseEnter={this.hoverOn} 
                        onMouseLeave={this.hoverOff}
                        bsStyle="success" onClick={this.removePromoCode}
                      >
                        Remove
                      </Button>
                      }
                    </Col>
                  </Row>
                  {this.state.show &&
                    this.state.alertMessage !== "" &&
                    this.state.promoStatus == 1 && (
                      <div className="col-lg-12">
                        <Alert
                          bsStyle={this.state.msgType}
                          onDismiss={this.handleDismiss}
                        >
                          <strong>Message:</strong>{" "}
                          {this.state.alertMessage}
                        </Alert>
                      </div>
                    )}
                </div>
              </div>

            {/* Guest Container*/}
              {(this.state.checkoutType == 'guest') &&
              <div className="panel">
                <header className="panel-heading">
                  Guest Checkout
                </header>
                <div className="panel-body">
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formPromoCodeTitle">
                        <ControlLabel>Email</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.email}
                          placeholder="Enter Email"
                          onChange={this.handleGuestChange}
                          name="email"
                          style={{ borderColor: this.state.emailError }}
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup controlId="formPromoCode">
                        <ControlLabel>Date Of Birth (MM/DD/YYYY)</ControlLabel> <br/>
                        <DatePicker
                          onChange={this.onChangeStartDate}
                          value={this.state.dob}
                          className={(this.state.dobError) ? "error" : ""}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} xs={12}>
                      <p>By completing your purchase, you agree to the <a>Site Name</a> terms of service and privacy policy.</p>
                    </Col>
                  </Row>
                </div>
              </div>
              }
              {/* Billing Container*/}
              {total > 0 ? (
                <div className="panel">
                  <header className="panel-heading">Billing Information</header>
                  <div className="panel-body">
                    {localStorage.getItem("user") &&
                    this.state.environment == "" ? (
                      <div className="col-lg-12">
                        <Alert bsStyle="danger">
                          <strong>Error:</strong> Please contact your website
                          administrator!
                          <span>
                            <br />
                            <strong>Note:</strong> Payment option is not
                            configured by website administrator.
                          </span>
                        </Alert>
                      </div>
                    ) : (
                      <Row>
                        <Col md={12} xs={12}>
                          {!isEmpty(localStorage.getItem("user")) &&
                          (this.state.creditRemain > 0 && this.state.allow_store == 'yes') ? (
                            <FormGroup>
                              <Checkbox
                                name="paymentType"
                                value={this.state.creditRemain}
                                onClick={this.handleStoreCredit}
                                inline
                              >
                                Use store credit? You have ${
                                  this.state.creditRemain
                                }{" "}
                                that can be applied to this purchase
                              </Checkbox>
                            </FormGroup>
                          ) : null}
                        </Col>
                        {((total - this.state.creditAmount > 0) && this.state.payPalStatus == true) ? (
                          <Col md={12} xs={12}>
                            <FormGroup>
                              {(this.state.paymentMethod == "paypal") ? 
                                <Radio
                                  name="paymentType"
                                  value="paypal"
                                  checked={true}
                                  required="required"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  You will be redirected to Paypal (Total Amount:
                                  ${total - this.state.creditAmount})
                                </Radio>
                              :
                                <Radio
                                  name="paymentType"
                                  value="paypal"
        
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  You will be redirected to Paypal (Total Amount:
                                  ${total - this.state.creditAmount})
                                </Radio>
                              }
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {((total - this.state.creditAmount > 0)  && this.state.authorizenetStatus == true) ? (
                          <Col md={12} xs={12}>
                            <FormGroup>
                              {(this.state.paymentMethod == "card") ? 
                                <Radio
                                  name="paymentType"
                                  value="card"
                                  required="required"
                                  checked={true}
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  Credit/Debit Card Payment (Total Amount: ${total -
                                    this.state.creditAmount})
                                </Radio>
                              :
                                <Radio
                                  name="paymentType"
                                  value="card"
                                  onClick={this.handlePaymentMethod}
                                  inline
                                >
                                  Credit/Debit Card Payment (Total Amount: ${total -
                                    this.state.creditAmount})
                                </Radio>
                              }
                            </FormGroup>
                          </Col>
                        ) : (
                          ""
                        )}
                        {(this.state.paymentMethod === "card" && (total - this.state.creditAmount > 0)) ? (
                          <Col md={12} xs={12}>
                            <Row>
                              {(this.state.card_data !== '' && this.state.check_card == 1) &&
                              <Col md={12} xs={12}>
                                <Form inline>
                                  <FormGroup>
                                    <ControlLabel><Checkbox name="carData" onClick={this.handleCardData} inline>Use the existing credit card already on file
</Checkbox></ControlLabel>{' '}
                                    {(this.state.cardData == 0) &&
                                    <FormControl onChange={this.creditCardValue} componentClass="select" placeholder="select">
                                      <option value="">select</option>
                                      {this.state.card_data.map((card, index) =>
                                      <option value={index}>{'XXXXXXXXXXXX'+card.cardNumber.toString().substr(-4)}</option>
                                      )}
                                    </FormControl>
                                    }
                                  </FormGroup>{' '}
                                </Form><br/>
                              </Col>
                              }
                              {(this.state.check_card == 1 && this.state.showSaveCard == 0) &&
                              <Col md={12} xs={12}>
                                <Form inline>
                                  <FormGroup>
                                    <ControlLabel><Checkbox name="saveCardData" defaultChecked={(this.state.saveCardData == 0) ? true : false} onClick={this.handleSaveCardData} inline> Store your billing info for a speedier checkout next time?
</Checkbox></ControlLabel>{' '}
                                  </FormGroup>
                                </Form><br/>
                              </Col>
                              }
                              <Col md={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    Cardholder's First Name{" "}
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.cardHolderFirstName}
                                    placeholder="Enter First Name"
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state
                                        .cardHolderFirstNameError
                                    }}
                                    name="cardHolderFirstName"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    Cardholder's Last Name
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.cardHolderLastName}
                                    placeholder="Enter Last Name"
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state
                                        .cardHolderLastNameError
                                    }}
                                    name="cardHolderLastName"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    Credit Card Number (no spaces or dashes)
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.cardNumber}
                                    placeholder="XXXXXXXXXXXXXXXX"
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state.cardNumberError
                                    }}
                                    name="cardNumber"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={3} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    Expiration Date (mm/yy)
                                  </ControlLabel>
                                  <Row>
                                    <Col md={6} xs={12}>
                                      <FormControl
                                        type="text"
                                        value={this.state.cardMonth}
                                        placeholder="MM"
                                        onChange={this.handleChange}
                                        style={{
                                          borderColor: this.state.cardMonthError
                                        }}
                                        name="cardMonth"
                                      />
                                    </Col>
                                    <Col md={6} xs={12}>
                                      <FormControl
                                        type="text"
                                        value={this.state.cardYear}
                                        placeholder="YY"
                                        onChange={this.handleChange}
                                        style={{
                                          borderColor: this.state.cardYearError
                                        }}
                                        name="cardYear"
                                      />
                                    </Col>
                                  </Row>
                                </FormGroup>
                              </Col>
                              <Col md={5} xs={12}>
                                <FormGroup>
                                  <ControlLabel>
                                    Security Code (the 3 or 4 digits on the back
                                    of the card)
                                  </ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.securityCode}
                                    placeholder="XXX"
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state.securityCodeError
                                    }}
                                    name="securityCode"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row bsStyle="primary">
                              <Col md={12} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Billing Address</ControlLabel>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Address</ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.address}
                                    placeholder="Address"
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state.addressError
                                    }}
                                    name="address"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Address Line 2</ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.address2}
                                    placeholder="Address Line 2"
                                    onChange={this.handleChange}
                                    name="address2"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>City</ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.city}
                                    placeholder="City"
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state.cityError
                                    }}
                                    name="city"
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>State</ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.state}
                                    placeholder="State"
                                    onChange={this.handleChange}
                                    style={{
                                      borderColor: this.state.stateError
                                    }}
                                    name="state"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Zip Code</ControlLabel>
                                  <FormControl
                                    type="text"
                                    value={this.state.zip}
                                    placeholder=""
                                    onChange={this.handleChange}
                                    style={{ borderColor: this.state.zipError }}
                                    name="zip"
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={4} xs={12}>
                                <FormGroup>
                                  <ControlLabel>Phone Number</ControlLabel>
                                  <NumberFormat
                                    format="###-###-####"
                                    mask="_"
                                    className="form-control"
                                    name="phone"
                                    placeholder="Enter Phone Number"
                                    style={{ borderColor: this.state.phoneError }}
                                    value={this.state.phone}
                                    onChange={this.handleChange}
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          </Col>
                        ) : null}
                      </Row>
                    )}
                  </div>
                </div>
              ) : (
                <div className="panel">
                  <header className="panel-heading">Billing Information</header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>First Name </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderFirstName}
                                placeholder="Enter First Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .cardHolderFirstNameError
                                }}
                                name="cardHolderFirstName"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Last Name</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderLastName}
                                placeholder="Enter Last Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .cardHolderLastNameError
                                }}
                                name="cardHolderLastName"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row bsStyle="primary">
                          <Col md={12} xs={12}>
                            <FormGroup>
                              <ControlLabel>Billing Address</ControlLabel>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address}
                                placeholder="Address"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.addressError }}
                                name="address"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address Line 2</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address2}
                                placeholder="Address Line 2"
                                onChange={this.handleChange}
                                name="address2"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>City</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.city}
                                placeholder="City"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.cityError }}
                                name="city"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>State</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.state}
                                placeholder="State"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.stateError }}
                                name="state"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Zip Code</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.zip}
                                placeholder=""
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.zipError }}
                                name="zip"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Phone Number</ControlLabel>
                              <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="phone"
                                placeholder="Enter Phone Number"
                                style={{ borderColor: this.state.phoneError }}
                                value={this.state.phone}
                                onChange={this.handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              )}

              {total - this.state.creditAmount <= 0 ? (
                <div className="panel">
                  <header className="panel-heading">Billing Information</header>
                  <div className="panel-body">
                    <Row>
                      <Col md={12} xs={12}>
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>First Name </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderFirstName}
                                placeholder="Enter First Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .cardHolderFirstNameError
                                }}
                                name="cardHolderFirstName"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Last Name</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.cardHolderLastName}
                                placeholder="Enter Last Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .cardHolderLastNameError
                                }}
                                name="cardHolderLastName"
                              />
                            </FormGroup>
                          </Col>
                        </Row>

                        <Row bsStyle="primary">
                          <Col md={12} xs={12}>
                            <FormGroup>
                              <ControlLabel>Billing Address</ControlLabel>
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address}
                                placeholder="Address"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.addressError }}
                                name="address"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address Line 2</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.address2}
                                placeholder="Address Line 2"
                                onChange={this.handleChange}
                                name="address2"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>City</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.city}
                                placeholder="City"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.cityError }}
                                name="city"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>State</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.state}
                                placeholder="State"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.stateError }}
                                name="state"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Zip Code</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.zip}
                                placeholder=""
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.zipError }}
                                name="zip"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Phone Number</ControlLabel>
                              <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="phone"
                                placeholder="Enter Phone Number"
                                style={{ borderColor: this.state.phoneError }}
                                value={this.state.phone}
                                onChange={this.handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="panel">
                  <header className="panel-heading">Shipping Address</header>
                  <div className="panel-body">
                        <Row>
                          <Col md={6} xs={12}>
                          <FormGroup>
                            <Checkbox name="sameAsBillingAddress" onClick={this.sameAsBillingAddress}>Same as Billing Address</Checkbox>
                          </FormGroup>
                          </Col>
                          {(this.state.charity && this.state.charityOption == 'enable') &&
                            <Col md={4} xs={4}>
                            <FormGroup>
                              <ControlLabel>Charity:</ControlLabel>
                              <FormControl
                                value={this.state.charity_id}
                                onChange={this.handleChange}
                                componentClass="select"
                                name="charity_id"
                                placeholder="select"
                              >
                                <option value="">Please select charity</option>
                                {this.state.charity.map((data, key) => 
                                  <option key={data.charity_id} value={data.charity_id}>{data.charity_name}</option>
                                )}
                              </FormControl>
                            </FormGroup>
                            </Col>
                          }
                        </Row>
                        
                        {(this.state.sameAsBillingAddress == 0) &&
                        <Row>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>First Name </ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.shippingFirstName}
                                placeholder="Enter First Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .shippingFirstNameError
                                }}
                                name="shippingFirstName"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={6} xs={12}>
                            <FormGroup>
                              <ControlLabel>Last Name</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.shippingLastName}
                                placeholder="Enter Last Name"
                                onChange={this.handleChange}
                                style={{
                                  borderColor: this.state
                                    .shippingLastNameError
                                }}
                                name="shippingLastName"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        }
                        {(this.state.sameAsBillingAddress == 0) &&
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.shippingAddress}
                                placeholder="Address"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.shippingAddressError }}
                                name="shippingAddress"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Address Line 2</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.shippingAddress2}
                                placeholder="Address Line 2"
                                onChange={this.handleChange}
                                name="shippingAddress2"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>City</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.shippingCity}
                                placeholder="City"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.shippingCityError }}
                                name="shippingCity"
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        }
                        {(this.state.sameAsBillingAddress == 0) &&
                        <Row>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>State</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.shippingState}
                                placeholder="State"
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.shippingStateError }}
                                name="shippingState"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Zip Code</ControlLabel>
                              <FormControl
                                type="text"
                                value={this.state.shippingzip}
                                placeholder=""
                                onChange={this.handleChange}
                                style={{ borderColor: this.state.shippingzipError }}
                                name="shippingzip"
                              />
                            </FormGroup>
                          </Col>
                          <Col md={4} xs={12}>
                            <FormGroup>
                              <ControlLabel>Phone Number</ControlLabel>
                              <NumberFormat
                                format="###-###-####"
                                mask="_"
                                className="form-control"
                                name="shippingPhone"
                                placeholder="Enter Phone Number"
                                style={{ borderColor: this.state.shippingPhoneError }}
                                value={this.state.shippingPhone}
                                onChange={this.handleChange}
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        }
                  </div>
                </div>
              {(sendAsGift === 1) &&
              <div className="panel">
                <header className="panel-heading">Gift Recipient Shipping Information</header>
                <div className="panel-body">
                  <Row>
                    <Col md={12} xs={12}>
                      <FormGroup>
                        <Checkbox onChange={this.handleBillingInfo} name="giftBillingInfo" defaultChecked={this.state.giftBillingInfo}>Same as Billing Information</Checkbox>
                      </FormGroup>
                    </Col>
                  </Row>
                  {(!this.state.giftBillingInfo) &&
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>First Name</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.giftFirstName}
                          placeholder="Address"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.giftFirstNameError }}
                          name="giftFirstName"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>Last Name</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.giftLastName}
                          placeholder="City"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.giftLastNameError }}
                          name="giftLastName"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  }
                  {(!this.state.giftBillingInfo) &&
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>Address</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.giftAddress}
                          placeholder="Address"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.giftAddressError }}
                          name="giftAddress"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>City</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.giftCity}
                          placeholder="City"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.giftCityError }}
                          name="giftCity"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  }
                  {(!this.state.giftBillingInfo) &&
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>State</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.giftState}
                          placeholder="Address"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.giftAddressError }}
                          name="giftState"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>Zip Code</ControlLabel>
                        <FormControl
                          type="text"
                          value={this.state.giftZip}
                          placeholder="City"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.giftZipError }}
                          name="giftZip"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  }
                  <Row>
                     <Col md={12} xs={12}>
                        <header className="panel-heading">Gift Details</header>
                     </Col>
                  </Row>
                  <Row>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>Recipient Name</ControlLabel>
                        <FormControl
                          type="text"
                          value={(this.state.recipientName) ? this.state.recipientName : recipientName}
                          placeholder="Address"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.recipientNameError }}
                          name="recipientName"
                        />
                      </FormGroup>
                    </Col>
                    <Col md={6} xs={12}>
                      <FormGroup>
                        <ControlLabel>Recipient Email</ControlLabel>
                        <FormControl
                          type="text"
                          value={(this.state.recipientEmail) ? this.state.recipientEmail : recipientEmail}
                          placeholder="City"
                          onChange={this.handleChange}
                          style={{ borderColor: this.state.recipientEmailError }}
                          name="recipientEmail"
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={12}>
                      <FormGroup controlId="formControlsTextarea">
                        <ControlLabel>Personal Message</ControlLabel>
                        <FormControl 
                          componentClass="textarea" 
                          name="personalMessage" 
                          value={(this.state.personalMessage) ? this.state.personalMessage : personalMessage}
                          onChange={this.handleChange}
                          style={{borderColor:this.state.personalMessageError}}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                </div>
              </div>
              }
              <Col md={12} xs={12}>
                <Col md={12} xs={12}>
                  <FormGroup>
                    <b>
                      ***Tax Rate applied on Shipping Address. Please view updated
                      Grand Total above.***
                    </b>
                  </FormGroup>
                </Col>
                <Col md={12} xs={12}>
                  <FormGroup>
                    By completing this order, you agree to the{" "}
                    <Link replace to="">offer terms</Link> and our{" "}
                    <Link replace to="">terms and conditions</Link>.
                  </FormGroup>
                </Col>
              </Col>
              {total > 0 ? (
                <Row className="BtnRow">
                  <Col md={12} xs={12} className="text-center">
                    {this.state.paymentMethod === "paypal" ? (
                      <PaypalExpressBtn
                        env={env}
                        client={client}
                        shipping={2}
                        currency={currency}
                        total={total - this.state.creditAmount}
                        onError={onError}
                        onSuccess={onSuccess}
                        onCancel={onCancel}
                      />
                    ) : this.state.paymentMethod === "card" ? (
                      <Button
                        style={{backgroundColor: (this.state.hover && this.state.hoverID == 'paynow') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                        data-id = {'paynow'}
                        onMouseEnter={this.hoverOn} 
                        onMouseLeave={this.hoverOff}
                        bsStyle="success"
                        type="submit"
                        onClick={this.totalAmount.bind(
                          this,
                          total - this.state.creditAmount
                        )}
                        disabled={this.props.paying}
                      >
                        Pay Now
                      </Button>
                    ) : (
                      <Button 
                        style={{backgroundColor: (this.state.hover && this.state.hoverID == 'checkouts') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                        data-id = {'checkouts'}
                        onMouseEnter={this.hoverOn} 
                        onMouseLeave={this.hoverOff}
                        bsStyle="success" 
                        type="submit"
                      >
                        Checkout
                      </Button>
                    )}
                  </Col>
                </Row>
              ) : (
                <Row className="BtnRow">
                  <Col md={12} xs={12} className="text-center">
                    <Button 
                      style={{backgroundColor: (this.state.hover && this.state.hoverID == 'checkout') ? this.state.mouseover_color : (this.state.button_color) ? this.state.button_color : '#77C84E' }}
                      data-id = {'checkout'}
                      onMouseEnter={this.hoverOn} 
                      onMouseLeave={this.hoverOff}
                      bsStyle="success" 
                      type="submit"
                    >
                      Checkout
                    </Button>
                  </Col>
                </Row>
              )}
              {this.state.show &&
                this.state.alertMessage !== "" &&
                this.state.promoStatus == 0 && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>Message:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
            </div>
          </form>
        )}
        <hr />
      </div>
    );
  }
}

// export default Dashboard;

Checkout.propTypes = {
  getCartDetail: PropTypes.func.isRequired,
  checkout: PropTypes.func.isRequired,
  getPaymentSetting: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  error: state.frontReducer.error,
  paying: state.frontReducer.paying,
  cartError: state.frontReducer.cartError,
  checkoutStatus: state.frontReducer.checkoutStatus,
  creditAmount: state.frontReducer.creditAmount,
  cartDetail: state.frontReducer.cartDetail,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message,
  promoStatus: state.frontReducer.promoStatus,
  promoError: state.frontReducer.promoError,
  paymentSetting: state.paymentSettingReducer.paymentSetting,
  getCharity: state.frontReducer.getCharity,
  removeStatus: state.frontReducer.promoRemoveStatus,
});

export default compose(
  connect(mapStateToProps, {
    getCartDetail,
    getPaymentSetting,
    checkout,
    renderAlert,
    clearAlert,
    applyPromoCode,
    removePromoCode,
    storeCredit,
    getcharityList
  })
)(Checkout);



// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/Checkout.js